declare const mxUtils: any;

import {ShapeCommand} from '../commands.template';
import {ConnectorJson} from './connector.commands';
import * as _ from 'lodash';

export class ChangeConTermStyleCommand extends ShapeCommand {
  // protected firstAction: boolean;
  protected services: any;
  mxKey;
  styleChange;
  reverseStyleChange;

  constructor(data: ConnectorJson, type: 'connector' | 'terminator') {
    super(data);
  }

  public prepareData(data): this {
    this.mxKey = data.flowlineMxKey;
    const flowline = _.find(this.services.diagramJsonSvc.get().flowlines, flowliney => {
      return (
        (flowliney.connector && +flowliney.connector.mxKey === +data.flowlineMxKey) ||
        (flowliney.terminator && +flowliney.terminator.mxKey === +data.flowlineMxKey)
      );
    });
    const conTermObject = flowline.connector || flowline.terminator;
    const newStyle = _.cloneDeep(conTermObject.styleObject);
    const newCustomStyle = _.cloneDeep(conTermObject.customStyle);

    this.styleChange = {style: newStyle, customStyle: newCustomStyle};

    this.reverseStyleChange = {style: data.style, customStyle: data.customStyle};

    return this;
  }

  private _changeStyle(mxKey, styleChange) {
    const flowline = _.find(this.services.diagramJsonSvc.get().flowlines, flowliney => {
      return (
        (flowliney.connector && +flowliney.connector.mxKey === +mxKey) ||
        (flowliney.terminator && +flowliney.terminator.mxKey === +mxKey)
      );
    });

    const itsConnector = !!flowline.connector;

    const conTermObj = flowline.connector || flowline.terminator;
    const actionName = itsConnector ? 'changeConnector' : 'changeTerminator';
    const type = itsConnector ? 'connector' : 'terminator';
    const mxStyles = itsConnector ? ['fillColor', 'strokeColor'] : ['fontColor'];
    const ourStyles = itsConnector ? ['mainColor', 'secondaryColor'] : ['mainColor'];

    conTermObj.styleObject = styleChange.style;
    conTermObj.customStyle = styleChange.customStyle;

    this.services.graphHelperSvc.mxStyleApply(
      mxStyles,
      ourStyles,
      conTermObj.mxKey,
      styleChange.customStyle,
      styleChange.style,
      type
    );

    const action = {};

    action[actionName] = {
      flowlineMxKey: flowline.mxKey,
      customStyle: styleChange.customStyle
    };

    if (styleChange.customStyle) {
      action[actionName].styleObject = styleChange.style;
    }

    return this.services.diagramUpdateSvc.update(action);
  }

  public execute() {
    super.execute();

    return this._changeStyle(this.mxKey, this.styleChange);
  }

  public reverse() {
    super.reverse();

    return this._changeStyle(this.mxKey, this.reverseStyleChange);
  }
}
